import TableView from 'mini-mail-list-store/lib/store/schema/TableView';
import { action } from 'satcheljs/lib/legacy';
import { FOLDER_MAILS_LOADED } from 'mini-mail-workflow-tracking/lib/constants/ListViewWorkflowConstants';
import { lazyPrefetchFirstN } from 'mini-mail-prefetch';
import { signalWorkflowEvent } from 'mini-workflow-manager';
import { TableQueryType } from 'mini-mail-list-store/lib/store/schema/TableQuery';

const FIRST_N_ROW_PREFETCH_COUNT = 10;

/**
 * Callback for table load complete
 * @param tableView the table view
 * @param isSuccessResponseClass indicates if the response is success
 * @param isTablePrefetched indicates if the table is prefetched
 */
export default action('onInitialTableLoadComplete')(function onInitialTableLoadComplete(
    tableView: TableView,
    isSuccessResponseClass: boolean,
    isTablePrefetched: boolean
) {
    // Set loading state to complete
    tableView.isLoading = false;
    tableView.isInitialLoadComplete = true;

    if (!isTablePrefetched) {
        tableView.hasErrorLoadingTable = !isSuccessResponseClass;
        if (isSuccessResponseClass && tableView.tableQuery.type !== TableQueryType.Search) {
            // prefetch first N rows for all tables except for Search table
            lazyPrefetchFirstN.importAndExecute(tableView, FIRST_N_ROW_PREFETCH_COUNT);
        }
    }

    // trigger workflow signal
    signalWorkflowEvent(
        FOLDER_MAILS_LOADED,
        undefined,
        undefined,
        !isSuccessResponseClass ? { error: new Error('Failed to load initial mails.') } : undefined
    );
});
